import React from 'react';
export function Footer() {
  return <footer className="bg-background border-t border-border py-12" data-id="element-19">
      <div className="container mx-auto px-4 md:px-6" data-id="element-20">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4" data-id="element-21">
          <div className="space-y-4" data-id="element-22">
            <h3 className="text-2xl font-bold text-primary" data-id="element-23">CafaPay</h3>
            <p className="text-muted-foreground text-sm max-w-xs" data-id="element-24">
              La solution de paiement pour les importateurs en Côte d'Ivoire.
              Simplifiez vos échanges avec la Chine, la Turquie et Dubaï.
            </p>
          </div>

          <div data-id="element-25">
            <h4 className="font-semibold text-foreground mb-4" data-id="element-26">Légal</h4>
            <ul className="space-y-2 text-sm text-muted-foreground" data-id="element-27">
              <li data-id="element-28">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-29">
                  Conditions d'utilisation
                </a>
              </li>
              <li data-id="element-30">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-31">
                  Politique de confidentialité
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-32">
            <h4 className="font-semibold text-foreground mb-4" data-id="element-33">Support</h4>
            <ul className="space-y-2 text-sm text-muted-foreground" data-id="element-34">
              <li data-id="element-35">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-36">
                  Contact
                </a>
              </li>
              <li data-id="element-37">
                <a href="#" className="hover:text-primary transition-colors" data-id="element-38">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-39">
            <h4 className="font-semibold text-foreground mb-4" data-id="element-40">Contact</h4>
            <p className="text-sm text-muted-foreground" data-id="element-41">
              Abidjan, Côte d'Ivoire
              <br data-id="element-42" />
              support@cafapay.com
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border text-center text-sm text-muted-foreground" data-id="element-43">
          <p data-id="element-44">© 2026 CafaPay. Tous droits réservés.</p>
        </div>
      </div>
    </footer>;
}